import { Injectable } from '@angular/core';
import { Partner } from '../interfaces/partner';
import firebase from 'firebase/compat/app';
import { addDoc, collection, doc, DocumentData, DocumentReference, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { from, Observable, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  private db = firebase.firestore();
  submitPartner(partnerData: Partner) {
    const formCollection = this.db.collection('pendingPartners');
    const id = this.db.collection('pendingPartners').doc().id;

    return new Observable<Partner>((observer) => {
      formCollection.doc(id).set({
        ...partnerData,
        id,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedAt: firebase.firestore.FieldValue.serverTimestamp()
      })
        .then(() => {
          observer.next({ ...partnerData, id });
          observer.complete();
        })
        .catch(err => observer.error(err));
    });
  }

  editPartner(partnerId: string, updatedData: Partial<Partner>): Observable<void> {
    const pendingRef = doc(firebase.firestore(), `pendingPartners/${partnerId}`);
    const partnerRef = doc(firebase.firestore(), `partner/${partnerId}`);

    return from(getDoc(pendingRef)).pipe(
      switchMap((pendingDoc) => {
        if (pendingDoc.exists()) {
          return from(updateDoc(pendingRef, { ...updatedData, modifiedAt: serverTimestamp() }));
        } else {
          return from(getDoc(partnerRef)).pipe(
            switchMap((partnerDoc) => {
              if (partnerDoc.exists()) {
                return from(updateDoc(partnerRef, { ...updatedData, modifiedAt: serverTimestamp() }));
              } else {
                return throwError(() => new Error('Partner not found in either collection.'));
              }
            })
          );
        }
      })
    );
  }

  async getPartners(): Promise<Partner[]> {
    // Firestore query: visibility-based
    let query = this.db.collection('partner') as firebase.firestore.Query;

    const snapshot = await query.get();
    const partners: Partner[] = [];

    snapshot.forEach(doc => {
      const data = { id: doc.id, ...doc.data() } as Partner;
      partners.push(data);
    });

    return partners;
  }

}
